// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__H0E1C","rootSuccess":"CompleteLink_rootSuccess__PDZOE","rootFailure":"CompleteLink_rootFailure__28xOd","isDisabled":"CompleteLink_isDisabled__1DNOK"};